<template>

  <!--
          代码层级说明
          .resume-main.is-page.page-index-${index}                  组件主题
            .scale                      简历缩放容器
              .main                     简历主题部分
                .main-page-${index}     简历页码
                  .content-scroll       每页简历主体，滚动部分
                    ......
        -->

  <div :id="download ? 'download-resume' : ''"
       :class="[ 'resume-main', className, isPage ? 'is-page' : '', cvDetail.basic_info && cvDetail.basic_info.lang || '', cvPageSize ]"
       ref="resumeMain"
       :style="{ height: `calc(${297 * page.length * scale}mm + ${10 * (page.length - 1) * scale}mm + 0mm)` }">

    <!-- 骨架图 -->
    <transition name="opacity">
      <skeleton :type="2" v-if="!visible"/>
    </transition>

    <!-- 简历预览区域 -->
    <div :class="['scale', visible ? 'visible' : '']" :style="{ transform: `scale(${scale})` }" :id="idName">
      <div class="cv-font-number" v-if="wordCount && !isShowDownloadResume" :style="{top: cvDetail.format_info.top_format === 'line' ? '27px' : '11px'}">
        字数: {{ wordCount }}
        <div class="hint" v-show="showWordNumHint">
          当前简历字数过少，请填写更多内容
        </div>
      </div>
      <div :ref="idName" class="is-page-margin" id="cv-container"
           :style="{ marginTop: `-${isPage ? (pageIndex - 1) * ((cvPageSize === 'letter_size' ? 279.4 : 297) + 10) : 0}mm`,
                  fontFamily:`${ fontFamily(userFontFamily, cvDetail.basic_info.lang,cvDetail.format_info.font) }`}">
        <template v-for="(p, j) in page">
          <div :class="['main', `main-${cvDetail.format_info.watermark}`, 'one-page-container', `page-index-${ j + 1 }`, `padding-${cvDetail.format_info.page_margin}`, `lineH-${ lineHeight }`,
              `fontsize-${ cvDetail.format_info.font_size }`, `${cvDetail.format_info.top_format}-header` ]" ref="pageMain" :key="j"
							v-show="openResumeError ? openResumeError && j===0 : true" :style="openResumeError ? { height: `${297 * page.length + page.length-1 * 10}mm` } : null"
					>
            <div class="header-line" v-show="cvDetail.format_info.top_format === 'line'" :style="{backgroundColor: cvDetail.format_info.top_line_color}"></div>
						<img
							v-if="cvDetail.format_info.pattern"
							class="cv-pattern"
							:src="cvDetail.format_info.pattern"
							:style="cvDetail.format_info.pattern_position === 'left' ? { transform: 'rotateY(180deg)' } : {}"
						></img>
            <div :class="['main-page-' + j]" class="content" ref="content" :data-page="j">
              <div class="content-scroll" ref="contentScroll" :style="{'margin-top': p.scroll + 'px'}" :data-page="j">
                <!-- 内容start -->
                <!-- 用户模块基本信息 -->
                <div :class="['user', cvDetail.format_info.head_format, 'avatar', cvDetail.basic_info.school_logo_url ? 'school-logo' : '', `show-attr-name-${profile.show_attr_name}`, `section-margin-${cvDetail.format_info.page_margin}`]"
                    v-if="cvDetail.format_info" @click="!isMentor && !openResumeError && editProfile('preview')">
                  <div class="user-info" :class="{'has-profile': profile.avatar_url || true}">
                    <div class="user-name" v-if="profile.username && profile.username !== '姓名'">
                      {{profile.username}}
                    </div>
                    <div v-else class="user-name">姓名</div>

                    <div class="profile-item" v-if="hasProfile">
                      <span v-if="profile.phone && profile.phone !== '电话'">
                        <i class="attr-icon iconfont icondianhua2"></i><label class="attr-name">{{cvDetail.basic_info.lang === 'cn' ? '电话' : 'Phone'}}：</label>{{profile.phone}}
                      </span>
                      <span v-if="profile.email && profile.email !== '邮箱'">
                        <i class="attr-icon iconfont iconyouxiang2"></i><label class="attr-name">{{cvDetail.basic_info.lang === 'cn' ? '邮箱' : 'Email'}}：</label>{{profile.email}}
                      </span>
                      <span v-if="profile.address">
                        <i class="attr-icon iconfont iconxianjuchengshi"></i><label class="attr-name">{{cvDetail.basic_info.lang === 'cn' ? '现居城市' : 'Address'}}：</label>{{profile.address}}
                      </span>
                    </div>

                    <div v-else class="no-profile-info">请填写你的基本信息</div>

                    <div class="profile-item">
                      <span v-if="profile.wechat">
                        <i class="attr-icon iconfont iconweixin2"></i><label class="attr-name">{{cvDetail.basic_info.lang === 'cn' ? '微信' : 'WeChat'}}：</label>{{profile.wechat}}
                      </span>
                      <span v-if="profile.linked_in">
                        <i class="attr-icon iconfont iconlingying"></i><label class="attr-name">{{cvDetail.basic_info.lang === 'cn' ? '领英' : 'LinkedIn'}}：</label>{{profile.linked_in}}
                      </span>
                      <span v-if="profile.homepage">
                        <i class="attr-icon iconfont icongerenwangzhan"></i><label class="attr-name">{{cvDetail.basic_info.lang === 'cn' ? '个人网站' : 'Website'}}：</label>{{profile.homepage}}
                      </span>
                    </div>

                    <div class="profile-item">
                      <!-- 年龄生日后续修改 -->
                      <span v-if="profile.birthday">
                        <i class="attr-icon iconfont iconnianling"></i><label class="attr-name">{{cvDetail.basic_info.lang === 'cn' ? (ageBirthday === 'age' ? '年龄' : '生日') : (ageBirthday === 'age' ? 'Age' : 'Birthdate')}}：</label>{{birthdayTypeValue}}
                      </span>
                      <span v-if="profile.gender">
                        <i :class="['attr-icon', 'iconfont', 'iconxingbie']"></i><label class="attr-name">{{cvDetail.basic_info.lang === 'cn' ? '性别' : 'Gender'}}：</label>{{profile.gender}}
                      </span>
                      <span v-if="profile.height">
                        <i class="attr-icon iconfont iconshengao"></i><label class="attr-name">{{cvDetail.basic_info.lang === 'cn' ? '身高' : 'Height'}}：</label>{{profile.height}}
                      </span>
                      <span v-if="profile.weight">
                        <i class="attr-icon iconfont icontizhong"></i><label class="attr-name">{{cvDetail.basic_info.lang === 'cn' ? '体重' : 'Weigth'}}：</label>{{profile.weight}}
                      </span>
                      <span v-if="profile.hometown">
                        <i class="attr-icon iconfont iconjiguan"></i><label class="attr-name">{{cvDetail.basic_info.lang === 'cn' ? '籍贯' : 'Hometown'}}：</label>{{profile.hometown}}
                      </span>
                      <span v-if="profile.ethnic">
                        <i class="attr-icon iconfont iconminzu"></i><label class="attr-name">{{cvDetail.basic_info.lang === 'cn' ? '民族' : 'Ethnic'}}：</label>{{profile.ethnic}}
                      </span>
                      <span v-if="profile.political_status">
                        <i class="attr-icon iconfont iconzhengzhimianmao"></i><label class="attr-name">{{cvDetail.basic_info.lang === 'cn' ? '政治面貌' : 'Political Status'}}：</label>{{profile.political_status}}
                      </span>
                      <span v-if="profile.marriage">
                        <i class="attr-icon iconfont iconhunyinzhuangkuang"></i><label class="attr-name">{{cvDetail.basic_info.lang === 'cn' ? '婚姻状况' : 'Marriage Status'}}：</label>{{profile.marriage}}
                      </span>
                    </div>

                    <div class="profile-item">
                      <span v-if="profile.current_job">
                        <i class="attr-icon iconfont icondangqiangongzuozhuangtai"></i><label class="attr-name">{{cvDetail.basic_info.lang === 'cn' ? '当前状态' : 'Current Status'}}：</label>{{profile.current_job}}
                      </span>
                       <span v-if="profile.exp_city">
                        <i class="attr-icon iconfont iconxianjuchengshi"></i><label class="attr-name">{{cvDetail.basic_info.lang === 'cn' ? '意向城市' : 'Expected City'}}：</label>{{profile.exp_city}}
                      </span>
                        <!-- 求职意向后续修改 -->
                      <span v-if="profile.exp_job">
                        <i class="attr-icon iconfont iconqiuzhiyixiang"></i><label class="attr-name">{{cvDetail.basic_info.lang === 'cn' ? '求职意向' : 'Objective'}}：</label>{{profile.exp_job}}
                      </span>
                      <span v-if="profile.expected_salary">
                        <i class="attr-icon iconfont iconqiwangxinzi"></i><label class="attr-name">{{cvDetail.basic_info.lang === 'cn' ? '期望薪资' : 'Expected Salary'}}：</label>{{profile.expected_salary}}
                      </span>
                    </div>

                  </div>
                  <div class="user-avatar">
                    <!-- 整体居中 头像 兼容pdf -->
                    <template v-if="cvDetail.format_info.head_format === 'body_center'">
                      <div class="user-avatar-image" v-if="profile.avatar_url" :style="{ backgroundImage: `url(${profile.avatar_url}` }"></div>
                    </template>
                    <template v-else>
                      <img class="user-avatar-image" v-if="profile.avatar_url" :src="profile.avatar_url" alt="">
                    </template>
										<template v-if="!profile.avatar_url">
                      <img class="user-avatar-image avatar-empty" src="https://logo.wondercv.com/banners/1XWFf7AqB7tYrl0.png" alt="">
                    </template>
                    <!-- <div v-if="!profile.avatar_url" class="default-avatar-new flex" :class="cvDetail.format_info.head_format" @click.stop="!isMentor && setPortraitDialogVisible(true)">
                      <img src="@/assets/image/cvs/default_avatar.png" alt="" />
                      <span>一键生成简历照</span>
                    </div> -->
                    <div class="user-picture-delete" @click.stop>
                      <p @click.stop="!isMentor&& setPortraitDialogVisible(true)"><i class="iconfont iconedit-"></i>{{profile.avatar_url ? '更换' : '上传' }}</p>
                      <p v-if="profile.avatar_url" @click.stop="!isMentor && deleteAvatar()"><i class="iconfont icontrash-"></i>删除</p>
                    </div>
                  </div>
                  <div class="user-school"
                       v-if="cvDetail.basic_info.school_logo_url" @click.stop="changeSchoolLogoState">
                    <img :src="cvDetail.basic_info.school_logo_url">
                  </div>
									<div class="mask pa" v-if="openResumeError" style="left:0; right: 0; top:0; bottom:0; z-index: 100"></div>
                </div>
                <!-- 大模块 -->
                <template v-for="(opt, num) in sectionPosition">
                  <!-- 模块有内容时 -->
                  <div class="option pr" :key="num" :class="[opt.type === 'custom' ? `custom-${ opt.id }` : opt.type]"
									 		:id="[opt.type === 'custom' ? `custom-${ opt.id }` : opt.type]"
                       v-if="(opt.type === 'extras' && extrasNotEmpty()) || getInfosByType(opt) && getInfosByType(opt).length"
                       @mouseover.stop="onMouseOver(opt.type === 'custom' ? `custom-${ opt.id }` : opt.type)"
                       @mouseleave.stop="onMouseLeave(opt.type === 'custom' ? `custom-${ opt.id }` : opt.type)">
                    <div :class="`section-margin-${cvDetail.format_info.page_margin}`" >
                      <module-title
												:item="opt"
												:index="num"
												:sPosition="sectionPosition"
												:titleType="cvDetail.format_info.title_format"
												:titleName="getSectionTitle(opt) || currentInfo.title"
												:titleTheme="cvDetail.format_info.title_color"
												:moduleType="opt.type"
												:showBtnData="{
													showBtnText: '添加',
													showBtnIcon: 'icontianjia',
													showBtnFlag: showAddIcon(opt),
													callback: () => {
														!openResumeError && editModule({description: ''}, opt, 'add');
														if (opt.type === 'works') {
															updateCommonIndex(-1)
														}
													}
												}" />
                    </div>
                    <ul class="menu extras pr" v-if="opt.type === 'extras' && extrasNotEmpty()"
                        :class="`section-margin-${cvDetail.format_info.page_margin}`"
                        @click="!openResumeError && editModule(extras, opt, 'edit')">
                      <template v-for="(item, num) in extrasPosition">
                        <li class="module-item extras-item pr" :key="num" v-if="extras[item] && extras[item].description">
                          <!-- 上下调整顺序按钮 -->
                          <div class="module-sort" v-if="!openResumeError">
                            <el-tooltip effect="dark" content="上移" placement="top">
                              <div class="iconfont iconshangyi1"
                                :class="[ num === 0 ? 'disabled' : null]" @click.stop="num === 0 ? null : sortExtrasModule(item, 'up', num)"></div>
                            </el-tooltip>
                            <el-tooltip effect="dark" content="下移" placement="top">
                              <div class="iconfont iconxiayi1"
                                :class="[ num === Object.keys(extrasPosition).length - 1 ? 'disabled' : null ]"
                                @click.stop="num === Object.keys(extrasPosition).length - 1 ? null : sortExtrasModule(item, 'down', num)"></div>
                            </el-tooltip>

                          </div>
                          <span class="font_w_b">{{ cvDetail.submodule_info[`${item}_title`]}}</span>
                          <span>{{extras[item] && extras[item].description }}</span>
                        </li>
                      </template>
                    </ul>
										<!-- 作品集 -->
										<template v-else-if="opt.type === 'opus' && getInfosByType(opt)">

                      <div class="menu pr section-item-container opus-container"
													:class="[ `section-margin-${cvDetail.format_info.page_margin}`]"
											>
											<!-- `section-${ item.id }`, -->
												<template v-for="(item, index) in getInfosByType(opt)">
														<!-- <div class="module-sort" v-if="getInfosByType(opt).length > 1">
															<div class="iconfont iconshangyi" :class="[ index === 0 ? 'disabled' : null ]"
																	@click.stop="index === 0 ? null : sortModule(opt, 'up', index)"></div>
															<div class="iconfont iconxiayi" :class="[index===getInfosByType(opt).length-1 ? 'disabled' : null]"
																	@click.stop="index === getInfosByType(opt).length - 1 ? null : sortModule(opt, 'down', index)"></div>
														</div> -->
													<div class="opu-item" :key="index"
														@click="!openResumeError && editModule(item, opt, 'edit')"
														@mouseover="onMouseOver(`section-${ item.id }`, 'section')"
														@mouseleave="onMouseLeave(`section-${ item.id }`, 'section')"
													>
														<img :src="item.qrcode" class="qrcode-img" v-if="item.qrcode">
														<div class="qrcode iconfont iconplus" v-else></div>
														<div class="desc" v-if="!item.url">{{item.title}}</div>
														<div class="desc link" v-else @click.stop="openOpuItemLink(item.url)"><span>{{item.title || `${cvDetail.basic_info.lang === 'cn' ? '作品链接' : 'portfolio link'}`}}</span></div>
														<!-- <a class="desc link" :href="item.url" target="_blank" v-else><span>{{item.title || `${cvDetail.basic_info.lang === 'cn' ? '作品链接' : 'portfolio link'}`}}</span></a> -->
													</div>
                      	</template>
                      </div>
										</template>
                    <template v-else>
                      <template v-for="(item, index) in getInfosByType(opt)">
                        <div class="menu pr section-item-container" :key="index"
                             :class="[`section-${ item.id }`, `section-margin-${cvDetail.format_info.page_margin}`]"
														 :id="[`${opt.type === 'custom' ? `custom` : opt.type}-${ item.id }`]"
                             @click="opt.type === 'works' ? editorModuleEx(item, opt, 'edit', index) : !openResumeError && editModule(item, opt, 'edit')"
                             @mouseover="onMouseOver(`section-${ item.id }`, 'section')"
                             @mouseleave="onMouseLeave(`section-${ item.id }`, 'section')"
												>
                        <!-- <h1>{{item}}</h1> -->
                          <div class="module-sort" v-if="getInfosByType(opt).length > 1 && !openResumeError">
                            <el-tooltip effect="dark" content="上移" placement="top">
                              <div class="iconfont iconshangyi1" :class="[ index === 0 ? 'disabled' : null ]"
                                @click.stop="index === 0 ? null : sortModule(opt, 'up', index)"></div>
                            </el-tooltip>
                            <el-tooltip effect="dark" content="下移" placement="top">
                              <div class="iconfont iconxiayi1" :class="[index===getInfosByType(opt).length-1 ? 'disabled' : null]"
                                @click.stop="index === getInfosByType(opt).length - 1 ? null : sortModule(opt, 'down', index)"></div>
                            </el-tooltip>
                            <el-tooltip effect="dark" content="删除" placement="top">
                              <div class="iconfont iconshanchu4" @click.stop="deleteExperience(item,opt.type)"></div>
                            </el-tooltip>
                          </div>
                          <template v-if="opt.type !== 'personal_summary' && opt.type !== 'skill_list'">
                            <!-- 一级标题 -->
                            <div class="menu-title" v-if="showMenuTitle(item, index, getInfosByType(opt))">
                              <div class="left flex1">
                                <span :class="{'font_w_b': opt.type !== 'honor'}">{{item.company || item.university || item.name}}</span>
                                <div class="school-tag-container" v-if="item.university && item.show_tags && item.show_tags.length && cvDetail.format_info.body_format === 'two_line'">
<!--                                  {{ JSON.stringify(item) }}-->
                                  <div class="school-tag-item" v-for="itemD in item.show_tags" :key="itemD">
                                    {{ itemD }}
                                  </div>
                                </div>
                                <!-- <span>==</span> -->
                                <span v-if="cvDetail.format_info.punctuation_format === 'show_punctuation' &&
                                                                    cvDetail.format_info.body_format === 'one_line' &&
                                                                    (item.company || item.university || item.name) &&
                                                                    (item.major || item.uni_school || item.title || item.dept || item.degree)"> - </span>
                                <template v-if="cvDetail.format_info.body_format === 'one_line'">
                                  {{item.major}}
                                  {{item.degree_id | degree(myself, item.degree) }}
                                  {{item.uni_school}}
                                  {{item.title}} {{item.dept}}
                                </template>
                              </div>
                              <div class="right"
                                   v-if="cvDetail.format_info.format_priority !== 'city' || cvDetail.format_info.body_format === 'one_line'">
                                <span v-if="item.start_at">{{moment(item.start_at).format('YYYY.MM') | date(cvDetail)}}</span>
                                <span v-if='item.start_at && (item.end_at || item.present)'> - </span>
                                <span v-if="item.end_at">{{moment(item.end_at).format('YYYY.MM') | date(cvDetail)}}</span>
                                <span v-if="item.present">{{item.present}}</span>
                              </div>
                              <div class="right" v-else>{{item.city}}</div>
                            </div>
                            <!-- 子标题 -->
                            <div class="menu-title"

                                 v-if="showMenuSTitle(item) && cvDetail.format_info.body_format !== 'one_line'">
                              <div class="left flex1">
                                {{item.major}} {{item.degree_id | degree(myself, item.degree)}}
                                {{item.uni_school}}
                                {{item.title}} {{item.dept}}
                              </div>
                              <div class="right" v-if="cvDetail.format_info.format_priority === 'city'">
                                <span v-if="item.start_at">
                                  {{moment(item.start_at).format('YYYY.MM') | date(cvDetail)}}
                                </span>
                                <span v-if='item.start_at && (item.end_at || item.present)'> - </span>
                                <span v-if="item.present !== '至今' && item.end_at">
                                  {{moment(item.end_at).format('YYYY.MM') | date(cvDetail)}}
                                </span>
                                <span v-if="item.present">{{item.present}}</span>
                              </div>
                              <div class="right" v-else>{{item.city}}</div>
                            </div>
                          </template>
                          <div class="menu-content-wrapper pr">
                            <div class="school-tag-container online-tag" v-if="item.university && item.show_tags && item.show_tags.length && cvDetail.format_info.body_format === 'one_line'">
                              <!--                                  {{ JSON.stringify(item) }}-->
                              <div class="school-tag-item" v-for="itemD in item.show_tags" :key="itemD">
                                {{ itemD }}
                              </div>
                            </div>
                            <div class="menu-content" v-html="item.description"></div>
														<!-- 展示划词的集合 -->
           									<div class="matchTipsContent"></div>
														<!-- 计算位置的div -->
            								<div class="menu-content matchTextContent pa"></div>
                            <div class="mask"></div>
                          </div>
                        </div>
                      </template>
                      <!-- 子模块 -->
                    </template>
                  </div>
                  <!-- 模块没有内容时 -->
                  <div v-else class="option default-text-option" :class="[opt.type === 'custom' ? `custom-${ opt.id }` : opt.type]" :key="num">
                    <div :class="`section-margin-${cvDetail.format_info.page_margin}`">
                      <module-title
												:item="opt"
												:index="num"
												:sPosition="sectionPosition"
												:titleType="cvDetail.format_info.title_format"
												:titleName="getSectionTitle(opt) || currentInfo.title"
												:titleTheme="cvDetail.format_info.title_color"
												:moduleType="opt.type"
												:showBtnData="{
													showBtnText: '添加',
													showBtnIcon: 'icontianjia',
													showBtnFlag: showAddIcon(opt),
													callback: () => {
														!openResumeError && editModule({description: ''}, opt, 'add');
														if (opt.type === 'works') {
															updateCommonIndex(-1)
														}
													}
												}" />
                    </div>
                    <div :class="`section-margin-${cvDetail.format_info.page_margin}`" class="default-text" @click="updateCommonIndex(-1); !openResumeError && editModule({description: ''}, opt, 'add')">
                      {{ placeholder[opt.type] }}
                    </div>
                  </div>
                </template>
                <!-- 内容end -->
              </div>
            </div>
						<!-- 简历纠错模式不显示 -->
						<template v-if="!openResumeError">
							<div class="cover cover-transparent" :style="{height: p.height + 'px'}"  @click.stop="handleClickWatermark"></div>
							<div class="cover" :style="{height: p.height + 'px'}"></div>
						</template>

          </div>
        </template>

				<!-- 错误提示信息 -->
				<div class="error-tips-content pa" :style="{left: `${selectErrorInfo.position.left>580 ? 580:selectErrorInfo.position.left}px`, top: `${selectErrorInfo.position.top}px`,}" @click.stop v-if="selectErrorInfo && selectErrorInfo.modelData">
					<div class="tips-info flex-c">
						<template v-if="selectErrorInfo.modelData.errorInfo.error_original_type !== 'redund'">
							<div class="tips-text wrong-word flex1">{{selectErrorInfo.modelData.errorInfo.wrong_word}}</div>
							<div class="iconfont iconyouce"></div>
							<div class="tips-text correct-word flex1">{{selectErrorInfo.modelData.errorInfo.correct_word}}</div>
						</template>
						<template v-else>
							<div class="tips-delete-text">建议删除</div>
							<div class="tips-text wrong-word flex1">{{selectErrorInfo.modelData.errorInfo.wrong_word}}</div>
						</template>
					</div>
					<div class="revise-button cursor_p text_center f_12 color_fff" @click="reviseErrorInfo(selectErrorInfo)">立即修改</div>
					<div class="next-button cursor_p text_center f_12" @click="nextErrorInfo({selectErrorInfo})">下一个</div>
   			</div>
      </div>
    </div>

  </div>

</template>
<script>
	import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
	import { random, getAbsolute } from '@/assets/js/util'
	import api from '@/api'
	import skeleton from '@/components/cvs/editor/img'
	import moment from 'moment'
	import degree from '@/assets/json/degree'
	import { dealCvDataMixin, cvMixin, cvResumeErrorMixin } from '../../../../../assets/js/mixins'
  import { addClass, removeClass } from '../../../../../assets/js/dom'
  import moduleTitle from '../moduleTitle'
	import { getErrorTextPosition, getErrorCorrectHtml, getOffsetRelative, getErrorTextRegExp } from '@/assets/js/editorError'
import { transform } from 'lodash'
	let elementResizeDetectorMaker = require('element-resize-detector')
	const erd = elementResizeDetectorMaker()

	// const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver
  // const listenEl = document.getElementById('cv-container')
  // const observer = MutationObserver(listenEl, {
  // 	childList: true, // 子节点变动
  //   attributes: true, // 属性变动
  //   characterData: true, // 节点内容或者节点文本变动
  //
	//   subtree: true,
	//   attributeFilter: ['style'],
  //   attributeOldValue: true,
  //   characterDataOldValue: true
  // })

	function getTop (e) {
		var offset = e.offsetTop
		if (e.offsetParent != null) offset += getTop(e.offsetParent)
		return offset
	}

	let page = [ { scroll: 0 } ]
	let resumeRun = false

	export default {
		name: 'resume',
		mixins: [ dealCvDataMixin, cvMixin, cvResumeErrorMixin ],
		components: {
      skeleton,
      moduleTitle
		},
		props: {
			autoPage: {
				type: Boolean,
				default: false
			},
			// 是否分页
			isPage: {
				type: false,
				required: false,
			},
			// 当前页码
			pageIndex: {
				type: Number,
				required: false,
				default: 1
			},
			// 是否缩放
			isScale: {
				type: Boolean,
				default: true
			},
			// 是否可以下载简历
			download: {
				type: Boolean,
				default: false
			},
			needSetOnePage: {
				type: Boolean,
				default: true
			}
		},
		data () {
			return {
				moment,
				className: 'resume-component-class-name-' + random(100000, 999999),
				idName: 'pdf' + random(1000, 9999), // id name
				scale: 1,
				visible: false,
				page,
				lineHeight: 12,
				cvHeight: 0, // 简历总高
				pageHeight: 0, // 容器高度
				pageMainHeight: 0, // 容器高度，加上padding
				page_size: 'a4', // 纸张大小
				cvPageSize: 'a4', // cv纸张大小
				myself: this,
        currentPage: 1,
				reviseErrorStatus: false, //是否正在修复错误中
			}
		},
		computed: {
			...mapState('cvsEditor', [ 'cvToken', 'list' ]),
			...mapState('editor', [ 'portraitDialogVisible', 'profile', 'cvDetail', 'extras', 'oldLineHeight', 'autoOnePage', 'resumeWidth',
				'currentInfo', 'backUpProfile', 'showScanner', 'wordCount', 'showWordNumHint', 'isShowDownloadResume', 'openResumeError', 'selectErrorInfo', 'errorUuidList',
				 'edus', 'orgs', 'works', 'resumeErrorFilterType', 'filterErrorInfo'
			]),
			...mapState('manage', ['menuList']),
			...mapGetters('cvs', [ 'cvs', 'cv' ]),
			...mapState('experience', [ 'userFontFamily', 'experienceList' ]),
      // 是否有基本信息
      hasProfile () {
				let notCheckField = ['created_at', 'format_pref', 'show_attr_name', 'updated_at']
        for (let k in this.profile) {
        	if (!notCheckField.includes(k) && this.profile[k]) {
		        return true
		        break
          }
        }
      },
      // 当前是选择的年龄还是生日
			ageBirthday () {
				if (this.profile.format_pref && this.profile.format_pref.age_birthday) {
					return this.profile.format_pref.age_birthday.chosen
				} else {
					return 'birthday'
				}
			},
      // 年龄或者生日的值
			birthdayTypeValue () {
				let { format_pref } = this.profile
				let { basic_info: { lang } } = this.cvDetail
				if (format_pref && format_pref.age_birthday && this.profile.birthday) {
					if(this.profile.birthday && this.profile.birthday.includes('**')){
						return '***'
					}
					// if((this.profile.birthday.includes('**')) || (format_pref.age_birthday.includes('**'))){
					// 	return '***'
					// }
					return format_pref.age_birthday.chosen === 'birthday' ? this.profile.birthday.slice(0, 7) :
						`${ moment().diff(this.profile.birthday, 'years') }${ lang === 'cn' ? '岁' : '' }`
				}
			},
      // 是否是导师
			isMentor () {
				return window.location.href.includes('mentor')
			},
		},
		watch: {
      scale (val) {
        this.$emit('resumeWidthFun', this.$refs[this.idName].offsetWidth * this.scale)
      },
			cvPageSize () {
				// this.visible = false
				setTimeout(() => {
					this.setPageView()
					this.$forceUpdate()
				}, 300)
			},
			cvDetail: {
				deep: true,
				immediate: true,
				handler (cvDetail) {
					// this.visible = false
					if(this.openResumeError){
						return
					}
					setTimeout(() => {
						this.setPageView()
						this.$forceUpdate()
					}, 300)
					this.cvPageSize = cvDetail.format_info && cvDetail.format_info.page_size || 'a4'
					this.lineHeight = cvDetail.format_info && cvDetail.format_info.line_spacing || 18
				}
			},
			// 提交page数量
			page: {
				deep: true,
				immediate: true,
				handler: function (page) {
					// this.$store.dispatch('cvs/setCvPages', page.length)
					this.$emit('get-pages', page.length)
					if (page.length === 0) {
						this.page = page
					}
				}
			},
			// 关闭纠错模式时，重新整理一下高度
			openResumeError(){
				console.log('openResumeError=>>',this.openResumeError)
				if(!this.openResumeError){
					setTimeout(() => {
						this.setPageView()
						this.$forceUpdate()
					}, 300)
					this.cvPageSize = this.cvDetail.format_info && this.cvDetail.format_info.page_size || 'a4'
					this.lineHeight = this.cvDetail.format_info && this.cvDetail.format_info.line_spacing || 18
				}
			},
		},
		filters: {
			date: function (value, cvDetail) {
				if (!value) {
					return ''
				}
				let {
					basic_info,
					format_info,
					submodule_info
				} = cvDetail
				let type = format_info.time_format
				let lang = basic_info.lang
				let reg = /(\d{4}).*?(\d{1,2}).*?/gim
				let str = ''
				if (lang === 'cn') {
					str = value.replace(reg, type === 'number' ? '$1.$2' : '$1年$2月')
				} else {
					let month = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov',
						'Dec'
					]
					let m = value.replace(reg, `$2`)
					let y = value.replace(reg, '$1')
					str = type === 'number' ? `${ y }.${ m }` : `${ month[m - 1] } ${ y }`
				}

				return str
			},
			age (d, type) {
				if (type !== 'age') {
					return d
				}
				if (!d) {
					return ''
				}
				let time = Date.now() - new Date(d).getTime()
				return Math.ceil(time / 1000 / 60 / 60 / 24 / 365) + '岁'
			},
			degree (id, myself, degreeName) {
				let item = degree.filter(item => item.id === id)
				let lang = myself.cvDetail.basic_info.lang
				return item.length ? item[0][lang || 'cn'] : (degreeName || '')
			}
		},
		async mounted () {
			// 一页纸功能方法存放到state中
			// if (this.onePage && this.autoPage) {
			//   this.$store.commit('cvs/setOnePage', this.onePage);
			// }
			// this.$store.commit('cvsEditor/setOnePage', this.onePage)
			// if (this.needSetOnePage) this.onePage()
			// console.log('重载进入生命周期')
			this.setOnePageFunction(this.onePage)
			this.visible = false
			await this.setPageView()
      this.changeEleResize()
			// this.visible = true
		},
		methods: {
			...mapActions('editor', [ 'updateCvDetail', 'getGroupsEntry', 'updateExperience', 'updateCustomInfo' ]),
      ...mapActions('manage', [ 'getFilterModule' ]),
			...mapMutations('editor', [ 'setModuleData', 'setPortraitDialogVisible', 'setOnePageFunction', 'setAutoOnePage', 'setOldLineHeight', 'setCvDetail', 'setOpenSidebarModule', 'setCheckCloseEditModule', 'setResumeErrorItemInfo', 'setErrorUuidList', 'setSelectErrorInfo', 'setIsSendRequest', 'updateCommonIndex', 'updateCompanyDisabled' ]),
			...mapMutations('experience', [ 'updateSidebarOption', 'updateExperienceModule', 'deleteExperienceSelect'  ]),
      ...mapMutations('manage', [ 'setMenuList' ]),
      ...mapActions('manage', [ 'getMenuList' ]),
      // 删除模块
			async deleteExperience ({id, custom_section_id},type) {
				const alertData = {
					...this.alertData,
					messageContent: `
          <p>删除后可以在页面右下角「经历库」内找回</p>
          <p style="color: #FF453E">确定删除本段经历吗?</p>
        `,
					confirm: async close => {
						let { submodule_info, basic_info } = this.cvDetail
            let { sections_position } = submodule_info;
            let infos = [];
            let payload = null;
            let moduleType = type
            // console.log(ids,'ids');
            // return
            // 基本模块
						if(['edus', 'orgs', 'works'].includes(type)) {
              let ids = submodule_info[`${ type }_ids`]
              infos = this[type].filter(item => item.id !== id)
              payload = {
                operation_type: 'update_submodule_info',
                submodule_info: {
                  [`${ type }_ids`]: ids.filter(i => i !== id)
                }
              }
            }
            else if(type !== 'extras' && type !== 'opus') {
              let position = JSON.parse(JSON.stringify(sections_position))
              if (type !== 'project_experience' && type !== 'reasearch_experience') {
                moduleType = custom_section_id
              }
              console.log(position,'position');
              position.forEach((val, index) => {
                if (val.id === custom_section_id) {
                  if(val.info_ids.length == 1){
                    position.splice(index, 1)
                  }else {
                    val.info_ids = val.info_ids.filter(item => item !== id)
                  }
                }
              })
              payload = {
                operation_type: 'update_submodule_info',
                submodule_info: {
                  sections_position: position
                }
              }
              let temp = (this.$store.state.editor[moduleType] || this.$store.state.editor.create_custom || [])
              infos = temp.filter(item => item.id !== id)
            } else if(type == 'extras') {
              payload = {
						  	operation_type: 'update_submodule_info',
                submodule_info: {
                  skill_id: null,
                  language_id: null,
                  certificate_id: null,
                  other_id: null,
                  interest_id: null
                }
						  }
            }
            if(basic_info.kind == 'sample' || basic_info.kind == 'template') {
              this.$message.error('请先编辑简历信息')
              return ;
            }
						let res = await this.updateCvDetail(payload)
						if (res.code === 1000) {
              // console.log(res)
							close()
							this.$message.success('删除成功')
							this.setModuleData({ type: moduleType, info: infos })
							//删除经历库某个模块选中状态
							this.deleteExperienceSelect({ type: moduleType, id })
							//重置
							!this.currentInfo.type && this.resetEditState()
              this.getMenuList()
						} else {
							this.$message.error(res.message)
						}
					},
					cancel: close => {
						close()
					},
				}
				this.setAlertData(alertData)
			},
      // 编辑经历
      editorModuleEx(item, opt, operation, index) {
        this.updateCommonIndex(index)
        !this.openResumeError && this.editModule(item, opt, operation, '', true)
      },
      // 打开更新校徽弹窗
			changeSchoolLogoState () {
				this.$store.dispatch('app/setAlertData', { show: true, type: 'school' })
				// this.updateSidebarOption('')
			},
			//打开作品集写的url
			openOpuItemLink(url){
				window.open(url.includes('//') ? url : `//${url}`)
			},
      // 删除模块
      deleteModule (data, index) {
				if (!this.currentInfo.operation) {
					let detail = JSON.parse(JSON.stringify(this.cvDetail))
					let { basic_info, submodule_info } = detail
					let menuList = JSON.parse(JSON.stringify(this.menuList))
					submodule_info.sections_position.splice(index, 1)
					menuList.splice(index, 1)
					if (basic_info.kind) {
						this.setCvDetail(detail)
					} else {
						let payload = {
							operation_type: 'update_submodule_info',
							submodule_info
						}
						this.updateCvDetail(payload)
					}
					this.setMenuList(menuList)
					this.getFilterModule()
        }
      },
      // 监听填写内容是超过当前总页数时dom的高度
      changeEleResize () {
        erd.listenTo(document.querySelectorAll('.content-scroll')[0], el => {
        	this.$nextTick(() => {
		        const onePageEl = document.querySelector('.content')
            let page = Math.ceil(el.clientHeight / onePageEl.clientHeight)
            if (page !== this.page.length) {
	            setTimeout(() => {
		            this.setPageView()
		            this.$forceUpdate()
	            }, 30)
            }
          })
        })
      },
      // 鼠标移入事件
      onMouseOver (className, type) {
				let elString =  `.${className}`
				const els = document.querySelectorAll(elString)
        for (let i = 0; i < els.length; i++) {
					addClass(els[i], type === 'section' ? 'section-high-light' : 'option-high-light')
        }
				// 如果正在纠错模式，阻拦
				if(this.openResumeError){
					return
				}
        this.$emit('resumeMouseover')
      },
      // 鼠标移出事件
      onMouseLeave (className, type) {
	      let elString =  `.${className}`
	      const els = document.querySelectorAll(elString)
	      for (let i = 0; i < els.length; i++) {
		      removeClass(els[i], type === 'section' ? 'section-high-light' : 'option-high-light')
	      }
	      this.$emit('resumeMouseleave')
      },
			// 是否显示添加按钮
			showAddIcon (opt) {
				// 如果正在纠错模式，阻拦
				if(this.openResumeError){
					return
				}
				let { type } = opt
				let { basic_info: { kind } } = this.cvDetail
				let showOpusAdd = true
				//作品集 && (不超过5个 || 是导师)
				if(opt.type === 'opus' && (this.getInfosByType(opt).length===5 || this.isMentor)){
					showOpusAdd = false
				}
        // kind 是否是自己的简历 null 自己的简历，有值就是大牛简历
        // this.currentInfo.operation 是否在编辑状态
				return type !== 'personal_summary' && type !== 'skill_list' && type !== 'extras' && (!kind || kind === "jobscan") && showOpusAdd
				// return type !== 'personal_summary' && type !== 'skill_list' && type !== 'extras' && !kind && !this.currentInfo.operation && showOpusAdd
			},
			// 计算缩放比例
			countScale () {
				this.$nextTick(async () => {
					setTimeout(() => {
						// console.log('pageMain=>>>', this.$refs.pageMain[0].offsetWidth)
						// console.log('resumeMain=>>>', this.$refs.resumeMain.offsetWidth)
						let resumeMain = this.$refs.resumeMain.offsetWidth
						window.resumeMain = this.$refs.resumeMain
						let pageMain = this.$refs.pageMain[0] ? this.$refs.pageMain[0].offsetWidth :
							720
						this.isScale && (this.scale = this.resumeWidth / pageMain)
						setTimeout(() => {
							this.visible = true
						}, 500)
						this.$emit('nextTick')
					}, 100)
				})
			},
			setPageInfo () {
				let contentHeight = this.$refs.content[0].offsetHeight
				let contentScrollHeight = this.$refs.contentScroll[0].offsetHeight
				let pageMainHeight = this.$refs.pageMain[0].offsetHeight
				this.cvHeight = contentScrollHeight // 简历总高度
				this.pageHeight = contentHeight // 页码容器高度
				this.pageMainHeight = pageMainHeight
			},
			// 一页纸
			async onePage (isClick) {
				let {
					kind
				} = this.cvDetail.basic_info
				clearTimeout(resumeRun)
				resumeRun = setTimeout(async () => {
					if (this.autoOnePage) {
						this.cvDetailChange(this.oldLineHeight, !this.autoOnePage)
						this.setAutoOnePage(!this.autoOnePage)
						this.$message.success('已取消一页纸')
						return false
					}
					// start count
					const minLineHeight = 12
					const maxLineHeight = 28
					const minFontSize = 12
					const maxFontSize = 18
					const errX = 10
					const fontSize = this.cvDetail.format_info.font_size
					const lineHeight = this.cvDetail.format_info.line_spacing
					// 设置存放一页纸原来数据
					if (!isClick) this.setOldLineHeight(lineHeight)
					// let isNoCount = lineHeight <= minLineHeight
					//   || fontSize >= lineHeight
					// let isOne = await this.isOnePage()
					// if (isNoCount || isOne) {
					//   return false
					// }
					// start set line height
					let isTrue = false // 是否可以实现一页纸
					let newLineHeight = lineHeight // 一页纸之后的行距
					if (this.cvHeight < this.pageHeight / 2 - 160 && isClick) {
						this.$message.error('内容过少，无法调整到一页纸')
						return false
					} else if (this.cvHeight > this.pageHeight * 2 + 160 && isClick) {
						this.$message.error('内容过多，无法调整到一页纸')
						return false
					}
					if (this.cvHeight < this.pageHeight) {
						for (let i = lineHeight; i <= maxLineHeight; i++) {
							this.lineHeight = i
							await this.$nextTick()
							await this.setPageInfo()
							let isOne = await this.isOnePage()
							if (isOne) {
								newLineHeight = i
								isTrue = true
							}
						}
					} else {
						for (let i = lineHeight - 1; i >= fontSize; i--) {
							this.lineHeight = i
							await this.$nextTick()
							await this.setPageInfo()
							let isOne = await this.isOnePage()
							if (isOne) {
								newLineHeight = i
								isTrue = true
								break
							}
						}
					}
					this.lineHeight = newLineHeight
					// 结束一页纸逻辑，进行展示
					if (isTrue) {
						this.cvDetailChange(newLineHeight, !this.autoOnePage)
						if (isClick) this.setAutoOnePage(!this.autoOnePage)
						if (!isClick && (kind === 'template' || kind === 'sample')) {
							return false
						}
						this.$message.success('已调整为一页纸')
					} else {
						if (isClick) {
							this.$message.error('内容过多无法一页纸，请删减内容或调整字号')
						}
					}
				}, 300)
			},
      // 更新简历详情的数据
			async cvDetailChange (lineHeight,isPage) {
				let { format_info } = this.cvDetail
				format_info = {
					...format_info,
					line_spacing: lineHeight,
          is_one_page: isPage
				}
				return await this.updateCvDetail({
          not_need_default_error_tips: true,
					operation_type: 'update_format_info',
					format_info
				})
			},
			// 是否已经一页纸
			isOnePage () {
				let errX = 6
				// let isTrue = this.cvHeight < this.pageHeight + errX
				//   && this.cvHeight > this.pageHeight - errX
				let isTrue = this.cvHeight < this.pageHeight
				if (isTrue) {
					this.page = [ {
						...this.page[0],
						height: 0
					} ]
				}
				return isTrue
			},
			// 计算高度 缩放比例
			setPageView () {
				// 如果是纠错模式，不计算高度
				if(this.openResumeError){
					return
				}
				const body = document.body
				if (!this.page.length) {
					this.page = page
				}
				// 高度计算(页面计算，偏移量计算)
				this.$nextTick(async () => {
					if (!this.$refs.content) {
						return false
					}
					if (!this.$refs.contentScroll[0] || !this.$refs.content[0]) {
						return false
					}
					let contentHeight = this.$refs.content[0].offsetHeight
					let contentScrollHeight = this.$refs.contentScroll[0].offsetHeight
					let page = []
					let length = (Math.ceil(contentScrollHeight / contentHeight)) || 1
					for (let i = 0; i < length; i++) {
						page[i] = {
							scroll: -contentHeight * i,
							height: 0
						}
					}
					this.page = page
					this.setPageInfo()
					// 遮挡计算
					this.$nextTick(async () => {
						for (let i = 0; i < this.page.length; i++) {
							await this.$nextTick(() => {
								// 当前页码内所有dom
								let domTitle = document.querySelectorAll(
									`.${ this.className }.resume-main .main-page-${ i } .title`
								)
								let domClass = document.querySelectorAll(
									`.${ this.className }.resume-main .main-page-${ i } .menu-title`
								)
								let domName = document.querySelectorAll(
									`.${ this.className }.resume-main .main-page-${ i } .name`
								)
								let domOl = document.querySelectorAll(
									`.${ this.className }.resume-main .main-page-${ i } ol`
								)
								let domLi = document.querySelectorAll(
									`.${ this.className }.resume-main .main-page-${ i } li`
								)
								let domP = document.querySelectorAll(
									`.${ this.className }.resume-main .main-page-${ i } p`
								)
								let dom = [ ...domTitle, ...domClass, ...domName, ...
									domOl, ...domLi, ...domP
								]
								// 当前页码容器dom
								let parent = document.querySelector(
									`.${ this.className }.resume-main .main-page-${ i }`
								)
								let contentHeight = parent.offsetHeight
								// let contentHeight = parent.offsetHeight
								// let parentTop = parent.offsetTop
								// let parentTop = 0
								let parentTop = getTop(parent)
								for (let j = 0; j < dom.length; j++) {
									// console.log(dom[j].children && dom[j].children[0]);
									// if (dom[j].children.length) {
									//   continue
									// }
									// let top = dom[j].offsetTop // 当前节点到top的距离
									let top = getTop(dom[j]) // 当前节点到top的距离
									let height = dom[j].offsetHeight // 当前节点的高度
									// 当前节点是否处于两页中间（半行字）
									let isTrue = parentTop + contentHeight > top &&
										parentTop + contentHeight < top + height
									if (isTrue) {
										let x = Math.abs(parentTop + contentHeight - top)
										let lineHeight = this.cvDetail.format_info.line_spacing - 0 // 行高
										let h = x % lineHeight + 4
										let page = this.page
										page[i].height = h
										// 修改page页码布局数据(元素偏移量)
										for (let k = 1; k < page.length; k++) {
											page[k].scroll = -Math.abs(Math.abs(page[k - 1].scroll) + contentHeight - page[k - 1].height)
										}
										this.page = page
									}
								}
							})
						}
						this.countScale()
					})
				})
			},
			//是否显示标题
			showMenuTitle (item, index, expArr) {
				let {
					format_info
				} = this.cvDetail
        // 此经历不是第一段经历 && 是子经历 && 公司名和上一段经历公司名相同 ====> 不显示主标题
        if (index > 0 && item.is_sub_item && (item.company === expArr[index - 1].company)) {
          return false
        }
				return item.company || item.university || item.name || (format_info.body_format === 'one_line' && (item
					.major || item.degree_id || item.uni_school || item.title || item.dept)) || (format_info
					.format_priority !== 'city' && (item.start_at || item.end_at || item.present)) || item.city
			},
			//是否显示小标题
			showMenuSTitle (item) {
				let {
					format_info
				} = this.cvDetail
				return item.major || item.degree_id || item.uni_school || item.title || item.dept || (format_info
					.format_priority === 'city' && (item.start_at || item.end_at)) || (format_info
					.format_priority !== 'city' && item.city)
			},
			fontFamily (userFontFamily, lang, fontId) {
				let list = userFontFamily[lang]
				let defaultFontFamily = lang === 'cn' ? 'PingFang SC, Microsoft YaHei' : 'Arial'
				let item = list ? list.filter(item => item.id === fontId && item.hasFont) : []
				return item.length ? `${ item[0].name.join(',') }` : defaultFontFamily
			},
      handleClickWatermark(){
			  let active = 'composing'
        console.log(this.currentInfo)
        if (this.currentInfo.operation) {
          //设置是否需要取消当前编辑状态，并返回
          this.setCheckCloseEditModule(true)
          //重置要打开的内容
          this.setOpenSidebarModule({
            state: false,
            type: active
          })
        }
        // this.showOption = false
        //增加延迟，防止watch时不生效
        setTimeout(() => {
          if (this.currentInfo.operation) {
            return false
          }
          //重置要打开的内容
          this.setOpenSidebarModule({
            state: false,
            type: ''
          })
          this.updateSidebarOption(active)
        }, 100)

      },

			// 修改错误
			reviseErrorInfo(selectErrorInfo){
				// console.log('reviseErrorInfo =>>> 状态=》〉》',this.reviseErrorStatus)
				// console.log(JSON.parse(JSON.stringify(selectErrorInfo)))
				// console.log(selectErrorInfo.modelPosition, selectErrorInfo.modelPosition[0])
				// 增加节流
				if(this.reviseErrorStatus){ return }
				this.reviseErrorStatus = true;
				let { modelPosition, modelData } = selectErrorInfo
				let { level2Index, errorInfo } = modelData
				let modelDataInfo = null; //当前错误信息的数据
				if(modelPosition[0] === 'custom'){
					modelDataInfo = this.getInfosByType({type: modelPosition[0], id: errorInfo.moduleId })
				}else{
					modelDataInfo = this.getInfosByType({type: modelPosition[0], id: modelPosition[1] })
				}
				// 当前修改的简历模块信息
				let editorModule = JSON.parse(JSON.stringify(modelDataInfo[level2Index]))
				// 当前修改的文字源数据
				let newOriginText = selectErrorInfo.originText;

				// console.log('更改之前', editorModule.description)
				// 查找要替换的文字，所在位置
				let findIndex = -1;
				// console.log('正则',RegExp(getErrorTextRegExp(errorInfo.wrong_word),'g'))
				Array.from(selectErrorInfo.originText.matchAll(RegExp(getErrorTextRegExp(errorInfo.wrong_word),'g')), (matchItem, matchIndex) => {
					// 判断下标是否是提示错误的下标位置
					if(matchItem.index === errorInfo.index){
						findIndex = matchIndex

						// 保存替换之后的html代码
						// 拿到截取字符串之前/之后的文字
						let beforeText = newOriginText.substring(0, matchItem.index);
						let afterText = newOriginText.substring(matchItem.index + errorInfo.wrong_word.length, newOriginText.length);
						newOriginText = `${beforeText}${errorInfo.correct_word || ''}${afterText}`;
						console.log(newOriginText)
					}
				})

				// 匹配带标签的错误所在位置
				Array.from(editorModule.description.matchAll(RegExp(errorInfo.regExp, 'g')), (matchItem, matchIndex) => {
					console.log('matchItem=>>', matchItem)
					// 带标签的第几个 === 不带标签的第几个
					if(matchIndex === findIndex){
						// 保存替换之后的html代码
						let correctHtml = getErrorCorrectHtml(errorInfo.correct_word, matchItem);
						// 拿到截取字符串之前/之后的文字
						let beforeText = editorModule.description.substring(0, matchItem.index);
						let afterText = editorModule.description.substring(matchItem.index + matchItem[0].length, editorModule.description.length);
						editorModule.description = `${beforeText}${correctHtml || ''}${afterText}`;
						// console.log(beforeText)
						// console.log(afterText)
					}
				})

				// 启动修改内容
				this.reviseResumeErrorInfo({
					editorModule,
					selectErrorInfo,
					quoteCallBack: ()=>{
						// 当前模块被引用，用户选择不修改
						// 取消用户节流
						this.reviseErrorStatus = false;
					},
					successCallBack: ()=>{
						// console.log('操作成功successCallBack')
						// 取消用户节流
						this.reviseErrorStatus = false;

						// 单独修改某一项数据
						this.setResumeErrorItemInfo({
							newOriginText, //替换之后的新文字
							offsetSize: errorInfo.correct_word.length - errorInfo.wrong_word.length, // index/end偏移量
							selectErrorInfo, //当前选择的错误信息
							moduleType: modelPosition[0], //当前类型
						})

						// 保存错误顺序
						let errorIndex = this.errorUuidList.indexOf(selectErrorInfo.className);
						console.log(this.errorUuidList, errorIndex, selectErrorInfo.className)

						// 去掉当前错误项
						let errorUuidList = this.errorUuidList.filter(item=> item !== selectErrorInfo.className)
						this.setErrorUuidList(errorUuidList);

						// 删除当前dom节点
						let currentErrorDom = document.querySelector(`.matchTipsContent .highlightContainer[data-uuid="${selectErrorInfo.className}"]`)
						if(currentErrorDom){
							currentErrorDom.remove();
						}

						// 如果替换之后长度变化了，重新计算当前错误向后的错误坐标
						// if(errorInfo.correct_word.length - errorInfo.wrong_word.length !== 0){
							// 修复一个错误之后，重新计算当前错误向后的错误坐标
							this.recalculateErrorDomPosition({
								selectErrorInfo,
								editorModule
							});
						// }

						// 如果还有错误，提示当前修改成功
						if(this.errorUuidList.length){
							this.$message.success('修改成功');
						}
						// 提交错误状态
						this.putCvErrorsStatus(selectErrorInfo, editorModule)

						setTimeout(() => {
							// 已修复当前错误，自动切换到下一个
							let nextClassName = this.errorUuidList[errorIndex] ? this.errorUuidList[errorIndex] : this.errorUuidList[0]
							// 进入下一个错误
							this.nextErrorInfo({ selectErrorInfo, nextClassName  })
						}, 200);

						// console.log('更改之后', editorModule)
						// console.log('modelDataInfo=>>>', modelDataInfo)

					}
				})

			},
			// 重新计算dom位置
			recalculateErrorDomPosition(props){
				let { selectErrorInfo, editorModule } = props
				let { modelPosition } = selectErrorInfo
				let filterErrorInfo = JSON.parse(JSON.stringify(this.filterErrorInfo));
				console.log('重新计算dom位置=>>selectErrorInfo', JSON.parse(JSON.stringify(selectErrorInfo)))
				console.log('重新计算dom位置=>>filterErrorInfo', JSON.parse(JSON.stringify(filterErrorInfo)))
				let fatherContent = document.querySelector(`#${modelPosition[0]}-${modelPosition[1]}`)
				// 清空当前错误里的位置
				if(fatherContent){
					fatherContent.querySelectorAll('.highlightContainer').forEach(errorDom=>{
						errorDom.remove()
					})
				}
				console.log('editorModule=>>>',editorModule)
				// console.log(fatherContent)

				// 循环大模块
				filterErrorInfo.forEach(modelItem=>{
					// 查找当前的大模块数据
					if(
						( (modelItem.type === 'edus' || modelItem.type === 'works' || modelItem.type === 'orgs') && modelItem.type === modelPosition[0] ) ||
						modelItem.id === selectErrorInfo.moduleId
					){
						// console.log('进到第1层')
						// 查找当前的小模块数据
						modelItem.errorInfos.forEach(infoItem=>{
							if(selectErrorInfo.infoId ? infoItem.infoId === selectErrorInfo.infoId : infoItem.moduleId === selectErrorInfo.moduleId){
								// console.log('进到第2层')
								// 计算html的方法
								let matchTextContent = document.querySelector(`#${modelItem.type}-${selectErrorInfo.infoId || selectErrorInfo.moduleId} .matchTextContent`);
								// 坐标展示的方法
								let matchTipsContent = document.querySelector(`#${modelItem.type}-${selectErrorInfo.infoId || selectErrorInfo.moduleId} .matchTipsContent`);

								// 循环错误点，重新添加坐标
								// console.log('errorList=>>>>',infoItem.errorList)
								infoItem.errorList.forEach((errorItem, errorIndex)=>{
									// console.log('进到第3层',errorItem.uuid, errorItem)
									// 如果已经修复，不走方法
									if(errorItem.is_correct){
										return
									}
									// 计算错误文字在纯文本中 第几个位置
									let findIndex = -1;
									Array.from(infoItem.originText.matchAll(RegExp(getErrorTextRegExp(errorItem.wrong_word),'g')), (matchItem, matchIndex) => {
										// 判断下标是否是提示错误的下标位置
										// console.log('重新获取坐标',matchItem.index , errorItem.index)
										if(matchItem.index === errorItem.index){
											findIndex = matchIndex
										}
									})
									// 没有获取到dom，不进行操作
									if(!matchTextContent || !matchTipsContent){
										console.log('没获取到dom', matchTextContent, matchTipsContent)
										return
									}
									// 添加锚点及功能
									Array.from(editorModule.description.matchAll(RegExp(errorItem.regExp, 'g')), (matchItem, matchIndex) => {
										// 带标签的第几个 === 不带标签的第几个
										// console.log(matchIndex, findIndex)
										if(matchIndex === findIndex){
											// console.log('进来了', errorItem)
											// 拿到截取字符串之前的文字
											let beforeText = editorModule.description.substring(0, matchItem.index);
											// console.log('match=>matchItem=>>>', matchItem)
											// console.log('beforeText=>>>', beforeText)

											// 添加dom
											let matchTextStartId = new Date().getTime();
											matchTextContent.innerHTML= `${beforeText}<span id="${matchTextStartId}">${matchItem[0]}</span>`
											// 插入元素的dom
											let positionDom = document.getElementById(matchTextStartId);
											// 计算需要获取错误提醒的位置及返回dom
											let TipsData = getErrorTextPosition({
												fatherContent: matchTextContent, // 父级元素
												positionDom, //元素
												errorItem, // 错误item
												modelItemType: modelItem.type,
												moduleId: selectErrorInfo.infoId || selectErrorInfo.moduleId, // 当前模块id
												wrap: false, //换行标记
											});
											// console.log('TipsData=>>>', TipsData)

											// 判断是否是折行，折行需要每个字都渲染一次
											if(TipsData.beyond){
												// console.log('超出预期高度')
												let spanList = ``
												let wrongWordList = errorItem.wrong_word.split('');
												wrongWordList.forEach(wordItem=>{
													spanList+=`<span class="${matchTextStartId}-matchTextStart">${wordItem}</span>`
												})
												// 添加dom
												matchTextContent.innerHTML= `${beforeText}${spanList}`
												document.getElementsByClassName(`${matchTextStartId}-matchTextStart`).forEach((domItem, domIndex)=>{
													// 计算需要获取错误提醒的位置及返回dom
													let newTipsData = getErrorTextPosition({
														fatherContent: matchTextContent, // 父级元素
														positionDom: domItem, //元素
														errorItem, // 错误item
														modelItemType: modelItem.type,
														moduleId: selectErrorInfo.infoId || selectErrorInfo.moduleId, // 当前模块id
														wrap: true, //换行标记
													});
													// console.log('超出高度,单个item',newTipsData, wrongWordList, domIndex, wrongWordList[domIndex])
													if(newTipsData.tipsDom){
														newTipsData.tipsDom.innerHTML = wrongWordList[domIndex]
													}
													matchTipsContent.append(newTipsData.tipsDom)
												})
											}else{
												// console.log('TipsData',TipsData)
												TipsData.tipsDom.innerHTML = matchItem[0]
												matchTipsContent.append(TipsData.tipsDom)
											}
											// console.log('new=>>errorItem+>>>>', errorItem)
										}
									})

								})

								// 增加绑定事件
								this.bindHighlightMethod( matchTipsContent.querySelectorAll('.highlightContainer'))
							}
						})

					}
				})
			},
			//下一个错误项
			nextErrorInfo(props){
				let { selectErrorInfo, nextClassName} = props
				if(!nextClassName){
					let errorIndex = this.errorUuidList.indexOf(selectErrorInfo.className);
					nextClassName = this.errorUuidList[errorIndex+1] ? this.errorUuidList[errorIndex+1] :this.errorUuidList[0]
				}

				if(!this.errorUuidList.length){
					// 关闭错误提示框
					this.setSelectErrorInfo(null)
					this.$message.success(this.resumeErrorFilterType ? `${this.errorInfoTypeName[this.resumeErrorFilterType]}已全部修改` : '当前简历没有错误啦');
					return
				}

				// 如果这就是最后一个
				if(selectErrorInfo.className === nextClassName){
					this.$message.success('已经是最后一个错误啦');
				}else{
					let nextDom = document.querySelector(`.matchTipsContent .highlightContainer[data-uuid="${nextClassName}"]`);
					let fatherDom = document.querySelector('.cvs-component')
					if( fatherDom && nextDom){
						let position = getOffsetRelative(nextDom).top*this.scale - getOffsetRelative(fatherDom).top;
						fatherDom.scrollTop = position-50
					}
					if(!nextDom){
						console.log('下一个错误找不到', nextClassName),
						console.log('filterErrorInfo=>>>>>', JSON.parse(JSON.stringify(this.filterErrorInfo)) )
					}
					nextDom && nextDom.click()
				}
			},
			// 提交错误状态
			putCvErrorsStatus(selectErrorInfo, editorModule){
				let { modelPosition, modelData } = selectErrorInfo
				let { errorInfo } = modelData
				let putCvErrorData = {
					error_type: errorInfo.error_original_type,
					index: errorInfo.position,
				}
				if(modelPosition[0] === 'works'){
					putCvErrorData.work_id = selectErrorInfo.moduleId
				}else if(modelPosition[0] === 'orgs'){
					putCvErrorData.org_id = selectErrorInfo.moduleId
				}else if(modelPosition[0] === 'edus'){
					putCvErrorData.edu_id = selectErrorInfo.moduleId
				}else {
					putCvErrorData.info_id = selectErrorInfo.moduleId
					putCvErrorData.custom_section_id = selectErrorInfo.infoId
				}
				console.log(putCvErrorData)
				api.cvError.putCvErrors(putCvErrorData)
			},
		},
    beforeDestroy () {
			erd.removeAllListeners()
		},
	}
</script>
<style lang="scss" scoped>
  @import './newResume.scss';
  .scale{
    position: relative;
    .cv-font-number{
      position: absolute;
      top: 11px;
      right: 13px;
      z-index: 3;
      font-size: 12px;
      color: #9c9c9c;
      .hint{
        position: absolute;
        text-align: center;
        line-height: 50px;
        font-size: 14px;
        font-weight: 500;
        color: #FFFFFF;
        width: 258px;
        height: 50px;
        background: #353944;
        box-shadow: 0px 2px 12px 0px rgba(128, 128, 128, 0.12);
        right: 0;
        top: 25px;
        border-radius: 6px;
        &::after{
          content: "";
          border: 6px solid #353944;
          position: absolute;
          border-top-color: transparent ;
          border-left-color: transparent ;
          border-right-color: transparent ;
          bottom: 49px;
          right: 20px
        }
      }
    }
  }
</style>
<style lang="scss">
  .resume-main {
    position: relative;
    ul,
    ol {
      padding-left: 20px;
    }
  }
  .cover-transparent{
    z-index: 4 !important;
    background-color: transparent !important;
  }

</style>
